import PropTypes from 'prop-types';
import {HelpMenuButton, SidePanel} from 'front-onceforall-core';

import HelpCenter from '../../../../views/helpCenter/HelpCenter';
import Contact from '../../../Contact';

function HelpMenuView(props) {
  let triggerClosePanel = () => {};
  return (
    <>
      <HelpMenuButton onClick={props.onHelpCenterClick}/>
      {props.isPanelOpen &&
        <SidePanel
          onClose={props.onClosePanel}
          big
          setCloseTrigger={closeFunction => {
            triggerClosePanel = closeFunction;
          }}
        >
          {props.isContactFormOpen &&
            <Contact
              selectedRequestType={props.requestType}
              onClose={props.onHelpCenterClick}
            />
          }
          {!props.isContactFormOpen &&
            <HelpCenter
              selectedHelpContent={props.helpContentId}
              currentPath={props.currentPath}
              onClose={() => triggerClosePanel()}
              onOpenContactForm={props.onContactClick}
            />
          }
        </SidePanel>
      }
    </>
  );
}

HelpMenuView.propTypes = {
  requestType: PropTypes.string,
  helpContentId: PropTypes.string,
  onHelpCenterClick: PropTypes.func.isRequired,
  isPanelOpen: PropTypes.bool.isRequired,
  onClosePanel: PropTypes.func.isRequired,
  isContactFormOpen: PropTypes.bool.isRequired,
  onContactClick: PropTypes.func.isRequired,
  currentPath: PropTypes.string.isRequired
};

export default HelpMenuView;
